import { CommonModule } from '@angular/common';
import { Component, input, output, AfterViewInit, ElementRef, inject, ViewChild, OnDestroy } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { TooltipService } from '../../services/tooltip.service';

@Component({
  selector: 'app-button-secondary',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './button-secondary.component.html',
  styles: ``
})
export class ButtonSecondaryComponent implements AfterViewInit, OnDestroy {
  public label = input<string>('');
  public disabled = input<boolean>(false);
  public buttonClicked = output<boolean>();
  public icon = input<string>('');
  public ghost = input<boolean>(false);
  public transparent = input<boolean>(false);

  // Tooltip inputs
  public tooltipTitle = input<string>('');
  public tooltipBody = input<string>('');
  public tooltipSpan = input<boolean>(false);
  public tooltipPlacement = input<'top' | 'top-end'>('top');

  private tooltipService = inject(TooltipService);

  @ViewChild('buttonRef') private buttonRef!: ElementRef;

  ngAfterViewInit() {
    if (this.tooltipBody()) {
      this.tooltipService.add({
        title: this.tooltipTitle(),
        body: this.tooltipBody(),
        span: this.tooltipSpan(),
        placement: this.tooltipPlacement(),
        targetElement: this.buttonRef.nativeElement
      });
    }
  }

  ngOnDestroy() {
    if (this.tooltipBody()) {
      this.tooltipService.remove(this.buttonRef.nativeElement);
    }
  }
}
